import mainBackground from "../assets/main-background.jpg";
import { WhatsappButton } from "./buttons/whatsapp";
import { TelegramButton } from "./buttons/telegram";
import { appendCurrentQueryParams, cn } from "../lib/utils";
import arrowIcon from "../assets/icons/arrow.svg";
import { AdVariant, WppButtonText } from "../App";

export type LandingPageTemplateProps = {
  header: string;
  vip: string[];
  discount: string;
  waText: string;
  waHref: string;
  waLeftIcon?: boolean;
  waRightIcon?: boolean;
  tgEnabled?: boolean;
  tgText: string;
  tgHref: string;
  members: string;
  footer: string;
  logo: string;
  gradient?: string;
  showJoinGroupHelp?: boolean;
  logoClassName?: string;
  adVariant?: AdVariant;
  wppButtonText?: WppButtonText;
};

export function LandingPageTemplate({
  header,
  vip,
  discount,
  waText: _waText,
  waHref,
  waLeftIcon = true,
  waRightIcon = true,
  tgText,
  tgHref,
  members,
  footer,
  logo,
  gradient,
  showJoinGroupHelp = true,
  logoClassName,
  adVariant: variant = "whatsapp",
  wppButtonText,
}: LandingPageTemplateProps) {
  const showWhatsapp = variant === "whatsapp" || variant === "all";
  const showTelegram = variant === "telegram" || variant === "all";
  const waText = wppButtonText || _waText;

  return (
    <div className="min-h-screen flex flex-col bg-black text-white text-center">
      {showJoinGroupHelp && (
        <img
          src={arrowIcon}
          alt=""
          className="absolute block md:hidden top-[19.805px] left-[335.596px] w-[24.2812px] h-[38.75px] rotate-[180.26deg] z-[118]"
        />
      )}

      <header
        className={cn(
          "items-center justify-center p-[15px] text-header-mobile md:text-header",
          showJoinGroupHelp ? "mt-9" : "",
        )}
      >
        <h1 className="sr-only">{header}</h1>
        <p aria-hidden>{header}</p>
      </header>

      <main
        className="relative flex-1 bg-cover bg-center p-[20px]"
        style={{
          backgroundImage: `url(${mainBackground})`,
        }}
      >
        <div
          className={`absolute inset-0 ${
            gradient || "bg-gradient-to-b from-black/60 to-blue-900/60"
          }`}
        />

        <section className="relative z-10 mx-auto flex max-w-screen-sm flex-col items-center gap-5 px-5 pt-5 pb-10 text-center">
          <div className="text-vip-group-title-mobile md:text-vip-group-title">
            {vip.map((line, idx) => (
              <p
                key={idx}
                className={idx !== vip.length - 1 ? "mb-[0.1875rem]" : ""}
              >
                {line}
              </p>
            ))}
          </div>

          <p className="text-discount-text">{discount}</p>

          <div className="my-0 md:my-5">
            <img
              src={logo}
              alt="Logo"
              className={cn("w-[120px] h-[120px] rounded-full", logoClassName)}
              loading="lazy"
              decoding="async"
            />
          </div>

          {showWhatsapp && (
            <div className="animate-tada-fast">
              <WhatsappButton
                className="cta-button-shadow"
                href={appendCurrentQueryParams(waHref)}
                ariaLabel={waText}
                hideLeftIcon={!waLeftIcon}
                hideRightIcon={!waRightIcon}
              >
                {waText}
              </WhatsappButton>
            </div>
          )}

          {showJoinGroupHelp && (
            <div className="md:hidden relative max-w-96 rounded-lg border p-4 bg-white-500/20 border-white-500 text-white-100 text-xs">
              <strong>⚠️ Não conseguiu entrar no grupo?</strong>
              <p className="font-light">
                Clique nos três pontinhos no canto superior direito e abra pelo
                navegador externo.
              </p>
            </div>
          )}

          {showTelegram && (
            <TelegramButton
              className="bg-blue-500 hover:bg-blue-600"
              href={appendCurrentQueryParams(tgHref)}
              ariaLabel={tgText}
            >
              {tgText}
            </TelegramButton>
          )}

          <p className="text-members-count">{members}</p>
        </section>
      </main>

      <footer className="px-5 py-[14px] text-footer text-center">
        {footer}
      </footer>
    </div>
  );
}
